<template>
  <div class="home">
    <Navbar :is-active="0"></Navbar>
    <div class="body form-page-body">
      <ConfiguracionSidebar :active="tab" />
      <div class="body__containt form-page-content">
        <div class="page__title form-page-title">
          <open-arrow></open-arrow>
          <div class="page__title-text">
            <h2>{{ title }}</h2>
            <p class="page__lead">{{ subtitle }}</p>
          </div>
        </div>

        <!-- Perfil -->
        <form v-if="tab === 'perfil'" class="form-card" @submit.prevent="updateUser">
          <div class="form-card__header">
            <div class="form-card__icon"><i class="far fa-user"></i></div>
            <div>
              <h3>Datos de perfil</h3>
              <p>Actualiza tu información de contacto.</p>
            </div>
          </div>
          <div class="form-grid">
            <div class="field">
              <span class="field__label">Fecha de creación</span>
              <input type="text" :value="dateFormat(created_at)" disabled />
            </div>
            <div class="field">
              <span class="field__label">Número de documento</span>
              <input type="text" :value="doc_number" disabled />
            </div>
            <label class="field">
              <span class="field__label">Celular</span>
              <input type="text" v-model="cellphone" />
            </label>
            <label class="field">
              <span class="field__label">Email</span>
              <input type="text" v-model="email" />
            </label>
            <label class="field">
              <span class="field__label">Nombre</span>
              <input type="text" v-model="user_name" />
            </label>
            <label class="field">
              <span class="field__label">Apellido</span>
              <input type="text" v-model="last_name" />
            </label>
          </div>
          <div class="form-actions">
            <button type="submit" class="btn btn--primary" :disabled="saving">
              <i class="fas fa-save"></i> {{ saving ? 'Guardando…' : 'Guardar cambios' }}
            </button>
          </div>
        </form>

        <!-- Contraseña -->
        <form v-else-if="tab === 'password'" class="form-card" @submit.prevent="updatePassword">
          <div class="form-card__header">
            <div class="form-card__icon"><i class="fas fa-lock"></i></div>
            <div>
              <h3>Cambiar contraseña</h3>
              <p>Ingresa tu clave actual y la nueva.</p>
            </div>
          </div>
          <div class="form-grid">
            <label class="field">
              <span class="field__label">Contraseña actual</span>
              <input type="password" v-model="password_actual" autocomplete="current-password" />
            </label>
            <label class="field">
              <span class="field__label">Nueva contraseña</span>
              <input type="password" v-model="password_new" autocomplete="new-password" />
            </label>
            <label class="field">
              <span class="field__label">Repetir contraseña nueva</span>
              <input type="password" v-model="repeat_password_new" autocomplete="new-password" />
            </label>
          </div>
          <div class="form-actions">
            <button type="submit" class="btn btn--primary" :disabled="saving">
              <i class="fas fa-save"></i> {{ saving ? 'Guardando…' : 'Guardar cambios' }}
            </button>
          </div>
        </form>

        <!-- Información de empresa (cliente) -->
        <form v-else-if="tab === 'empresa' && role === 'cliente'" class="form-card" @submit.prevent="updateCompany">
          <div class="form-card__header">
            <div class="form-card__icon"><i class="fas fa-building"></i></div>
            <div>
              <h3>Información de empresa</h3>
              <p>Datos generales, logo y contacto.</p>
            </div>
          </div>

          <h4 class="section-title">Información general</h4>
          <div class="form-grid">
            <div class="field">
              <span class="field__label">Fecha de creación</span>
              <input type="text" :value="dateFormat(fecha_company)" disabled />
            </div>
            <label class="field">
              <span class="field__label">RUC</span>
              <input type="text" v-model="company_ruc" />
            </label>
            <label class="field">
              <span class="field__label">Razón social</span>
              <input type="text" v-model="company_name" />
            </label>
            <label class="field">
              <span class="field__label">Grupo de negocio</span>
              <select v-model="company_bus_group_id">
                <option disabled value="">Seleccionar</option>
                <option v-for="item in business_group" :key="item.id" :value="item.id">{{ item.name }}</option>
              </select>
            </label>
            <label class="field">
              <span class="field__label">Tipo de negocio</span>
              <select v-model="company_bus_type_id">
                <option disabled value="">Seleccionar</option>
                <option v-for="item in business_type" :key="item.id" :value="item.id">{{ item.name }}</option>
              </select>
            </label>
            <label class="field">
              <span class="field__label">Conexión pasarela de pago</span>
              <select v-model="company_gat_connection_id">
                <option disabled value="">Seleccionar</option>
                <option v-for="item in gateway_connection" :key="item.id" :value="item.id">{{ item.name }}</option>
              </select>
            </label>
            <label class="field">
              <span class="field__label">Tipo de cliente</span>
              <select v-model="company_cus_type_id">
                <option disabled value="">Seleccionar</option>
                <option v-for="item in customer_type" :key="item.id" :value="item.id">{{ item.name }}</option>
              </select>
            </label>
            <label class="field">
              <span class="field__label">Tipo de conciliación</span>
              <select v-model="company_rec_type_id">
                <option disabled value="">Seleccionar</option>
                <option v-for="item in reconciliation_type" :key="item.id" :value="item.id">{{ item.name }}</option>
              </select>
            </label>
            <div class="field">
              <span class="field__label">Cantidad de sucursales</span>
              <input type="text" :value="cantidad_sucursales ? cantidad_sucursales : 0" disabled />
            </div>
          </div>

          <h4 class="section-title">Logo de la empresa</h4>
          <div class="logo-row">
            <div class="logo-preview">
              <img :src="company_url" alt="Logo empresa" />
            </div>
            <div class="logo-actions">
              <label class="btn btn--secondary">
                <i class="fas fa-upload"></i> Cargar imagen
                <input type="file" hidden @change="change_file" ref="fileupload" />
              </label>
              <button type="button" class="btn btn--ghost" @click="deleteImagen">
                <i class="far fa-trash-alt"></i> Eliminar imagen
              </button>
            </div>
          </div>

          <h4 class="section-title">Datos de contacto</h4>
          <div class="form-grid">
            <label class="field">
              <span class="field__label">Nombre</span>
              <input type="text" v-model="company_contact_name" />
            </label>
            <label class="field">
              <span class="field__label">Apellido</span>
              <input type="text" v-model="company_contact_lastname" />
            </label>
            <label class="field">
              <span class="field__label">Correo</span>
              <input type="text" v-model="company_contact_email" />
            </label>
            <label class="field">
              <span class="field__label">Celular</span>
              <input type="text" v-model="company_contact_cellphone" />
            </label>
          </div>
          <div class="form-actions">
            <button type="submit" class="btn btn--primary" :disabled="saving">
              <i class="fas fa-save"></i> {{ saving ? 'Guardando…' : 'Guardar cambios' }}
            </button>
          </div>
        </form>

        <!-- Configuración de empresa (admin) -->
        <form v-else-if="tab === 'empresa-admin' && role === 'admin'" class="form-card" @submit.prevent="updateEmpresa">
          <div class="form-card__header">
            <div class="form-card__icon"><i class="fas fa-building"></i></div>
            <div>
              <h3>Configuración de empresa</h3>
              <p>Teléfono institucional.</p>
            </div>
          </div>
          <div class="form-grid">
            <label class="field">
              <span class="field__label">Teléfono de empresa</span>
              <input type="text" v-model="cellphone_empresa" />
            </label>
          </div>
          <div class="form-actions">
            <button type="submit" class="btn btn--primary" :disabled="saving">
              <i class="fas fa-save"></i> {{ saving ? 'Guardando…' : 'Guardar cambios' }}
            </button>
          </div>
        </form>

        <!-- Entidades (admin) -->
        <div v-else-if="tab === 'entidades' && role === 'admin'" class="form-card">
          <div class="form-card__header">
            <div class="form-card__icon"><i class="fas fa-sitemap"></i></div>
            <div>
              <h3>Entidades</h3>
              <p>Pasarelas de pago disponibles.</p>
            </div>
          </div>
          <div class="form-grid">
            <label class="field field--full" style="max-width: 420px;">
              <span class="field__label">Añadir pasarela</span>
              <div class="add-row">
                <input type="text" v-model="add_gateway" placeholder="Nombre de la pasarela" />
                <button type="button" class="btn btn--primary" @click="gateway_add">
                  <i class="fas fa-plus"></i>
                </button>
              </div>
            </label>
          </div>
          <table class="simple-table">
            <thead>
              <tr>
                <th>N°</th>
                <th>Pasarela</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(gat, i) in gateway_connection" :key="gat.id || i">
                <td>{{ i + 1 }}</td>
                <td>{{ gat.name }}</td>
                <td>
                  <button type="button" class="btn btn--ghost" @click="deleteGateway(gat.id)">
                    <i class="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Facturación electrónica -->
        <div v-else-if="tab === 'facturacion'">
          <div v-if="nubefactLoading" class="form-card">
            <p style="margin:0; color:#888;">Cargando configuración…</p>
          </div>
          <form v-else class="form-card" @submit.prevent="saveNubefact">
            <div class="form-card__header">
              <div class="form-card__icon"><i class="fas fa-file-invoice"></i></div>
              <div>
                <h3>Configuración Nubefact de la empresa</h3>
                <p>URL, token y series se guardan por empresa.</p>
              </div>
            </div>
            <div class="form-grid">
              <div class="field">
                <span class="field__label">Estado</span>
                <div class="status-toggle">
                  <button type="button" :class="{ active: nubefact.enabled }" @click="nubefact.enabled = true">Activo</button>
                  <button type="button" :class="{ active: !nubefact.enabled }" @click="nubefact.enabled = false">Inactivo</button>
                </div>
              </div>
              <label class="field">
                <span class="field__label">IGV (%)</span>
                <input type="number" v-model.number="nubefact.igv" min="0" max="100" step="0.01" />
              </label>
              <label class="field">
                <span class="field__label">Serie factura</span>
                <input type="text" v-model="nubefact.serie_factura" maxlength="4" placeholder="FFF1" />
              </label>
              <label class="field">
                <span class="field__label">Serie boleta</span>
                <input type="text" v-model="nubefact.serie_boleta" maxlength="4" placeholder="BBB1" />
              </label>
              <label class="field field--full">
                <span class="field__label">Ruta API (URL Nubefact)</span>
                <input type="text" v-model="nubefact.url" placeholder="https://api.nubefact.com/api/v1/..." />
              </label>
              <label class="field field--full">
                <span class="field__label">
                  Token
                  <em v-if="nubefactMeta.has_token">— configurado: {{ nubefactMeta.token_masked }}</em>
                </span>
                <input
                  type="password"
                  v-model="nubefact.token"
                  :placeholder="nubefactMeta.has_token ? 'Dejar vacío para conservar el token actual' : 'Pega el token de Nubefact'"
                  autocomplete="new-password"
                />
              </label>
            </div>
            <div class="meta-row">
              <div class="meta-item">
                <span>Origen</span>
                <strong>{{ nubefactMeta.configured ? 'Configuración de empresa' : 'Fallback global (.env)' }}</strong>
              </div>
              <div class="meta-item">
                <span>Company ID</span>
                <strong>{{ id_company || '—' }}</strong>
              </div>
            </div>
            <div class="form-actions">
              <button type="submit" class="btn btn--primary" :disabled="saving">
                <i class="fas fa-save"></i> {{ saving ? 'Guardando…' : 'Guardar configuración' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Navbar from '@/components/NavBar.vue'
import ConfiguracionSidebar from '@/components/ConfiguracionSidebar.vue'
import OpenArrow from '@/components/OpenArrow.vue'
import { dateFormat } from '@/utils/formats'
import '@/static/css/form-card.css'

export default {
  name: 'Configuracion',
  components: { Navbar, ConfiguracionSidebar, OpenArrow },
  data() {
    return {
      saving: false,
      role: localStorage.getItem('role'),
      id: localStorage.getItem('id'),
      id_company: localStorage.getItem('company_id'),
      file: null,
      cellphone: '',
      created_at: '',
      email: '',
      user_name: '',
      last_name: '',
      doc_number: '',
      password_actual: '',
      password_new: '',
      repeat_password_new: '',
      cellphone_empresa: localStorage.getItem('cellphone') || '',
      company_ruc: '',
      company_name: '',
      company_url: location.protocol + '//' + location.host + '/default/default_product.jpg',
      fecha_company: '',
      company_bus_group_id: '',
      company_bus_type_id: '',
      company_gat_connection_id: '',
      company_cus_type_id: '',
      company_rec_type_id: '',
      cantidad_sucursales: 0,
      company_contact_name: '',
      company_contact_lastname: '',
      company_contact_email: '',
      company_contact_cellphone: '',
      business_group: [],
      business_type: [],
      customer_type: [],
      gateway_connection: [],
      reconciliation_type: [],
      add_gateway: '',
      nubefactLoading: false,
      nubefactLoaded: false,
      nubefact: {
        enabled: false,
        url: '',
        token: '',
        serie_factura: 'FFF1',
        serie_boleta: 'BBB1',
        igv: 18
      },
      nubefactMeta: {
        has_token: false,
        token_masked: '',
        source: '',
        configured: false
      }
    }
  },
  computed: {
    tab() {
      const requested = this.$route.query.tab || 'perfil'
      const allowed = ['perfil', 'password']
      if (this.role === 'cliente') allowed.push('empresa', 'facturacion')
      if (this.role === 'admin') allowed.push('empresa-admin', 'entidades')
      return allowed.includes(requested) ? requested : 'perfil'
    },
    title() {
      const map = {
        perfil: 'Perfil',
        password: 'Cambiar contraseña',
        empresa: 'Información de empresa',
        'empresa-admin': 'Configuración de empresa',
        entidades: 'Entidades',
        facturacion: 'Facturación electrónica'
      }
      return map[this.tab] || 'Configuración'
    },
    subtitle() {
      const map = {
        perfil: 'Datos de tu usuario.',
        password: 'Actualiza la clave de acceso.',
        empresa: 'Datos de la empresa activa.',
        'empresa-admin': 'Parámetros generales de empresa.',
        entidades: 'Catálogo de pasarelas de pago.',
        facturacion: 'Cada socio comercial emite con su propia cuenta Nubefact.'
      }
      return map[this.tab] || ''
    }
  },
  watch: {
    tab: {
      immediate: true,
      handler(val) {
        if (val === 'empresa' || val === 'entidades') {
          this.getSelects()
          if (val === 'empresa') this.getCompany()
        }
        if (val === 'facturacion' && !this.nubefactLoaded) this.loadNubefact()
      }
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push('/login')
    }
  },
  mounted() {
    this.getallb2c()
  },
  methods: {
    dateFormat,
    change_file(event) {
      this.file = event.target.files[0]
      if (!this.file) return
      const reader = new FileReader()
      if (this.file.type === 'image/png' || this.file.type === 'image/jpeg' || this.file.type === 'image/jpg') {
        reader.onload = (e) => {
          this.company_url = e.target.result
        }
        reader.readAsDataURL(this.file)
      } else {
        this.$swal({
          position: 'center',
          icon: 'error',
          title: 'El archivo no es un formato de imagen',
          showConfirmButton: false,
          timer: 2000
        })
      }
    },
    deleteImagen() {
      if (this.$refs.fileupload) this.$refs.fileupload.value = null
      this.file = null
      this.company_url = location.protocol + '//' + location.host + '/default/default_product.jpg'
    },
    cleanUrl(url) {
      return String(url || '').trim().replace(/[,;]+$/g, '').trim()
    },
    async getallb2c() {
      const { data } = await axios.get('general/b2c/client-by-id/' + this.id)
      this.cellphone = data.data.cellphone
      this.created_at = data.data.created_at
      this.email = data.data.email
      this.user_name = data.data.user_name
      this.last_name = data.data.user_lastname
      this.doc_number = data.data.user_doc_number
    },
    async getSelects() {
      const res = await axios.get('general/elements/selects')
      this.business_group = res.data.data.business_group
      this.business_type = res.data.data.business_type
      this.customer_type = res.data.data.customer_type
      this.gateway_connection = res.data.data.gateway_connection
      this.reconciliation_type = res.data.data.reconciliation_type
    },
    async getCompany() {
      if (!this.id_company) return
      const res = await axios.get('general/company/' + this.id_company)
      if (!res.data.data) return
      const company = res.data.data[0]
      this.company_ruc = company.company_ruc
      this.company_name = company.company_name
      this.company_url = company.company_url
      this.fecha_company = company.fecha
      this.cantidad_sucursales = company.branches
      this.company_contact_cellphone = company.company_contact_cellphone
      this.company_contact_email = company.company_contact_email
      this.company_contact_lastname = company.company_contact_lastname
      this.company_contact_name = company.company_contact_name
      this.company_rec_type_id = company.company_rec_type_id
      this.company_bus_group_id = company.company_bus_group_id
      this.company_bus_type_id = company.company_bus_type_id
      this.company_cus_type_id = company.company_cus_type_id
      this.company_gat_connection_id = company.company_gat_connection_id
    },
    async updateUser() {
      this.saving = true
      try {
        const respuesta = await axios.put('general/b2c/update/' + this.id, {
          email: this.email,
          user_name: this.user_name,
          user_lastname: this.last_name,
          cellphone: this.cellphone
        })
        if (respuesta.status === 200) {
          localStorage.setItem('usuario', this.user_name + ' ' + this.last_name)
          this.$swal({
            position: 'center',
            icon: 'success',
            title: 'Editado correctamente',
            showConfirmButton: false,
            timer: 2000
          })
        }
      } catch (error) {
        this.$swal({
          position: 'center',
          icon: 'error',
          title: 'Completar los datos correctamente',
          showConfirmButton: false,
          timer: 2000
        })
      } finally {
        this.saving = false
      }
    },
    async updatePassword() {
      if (this.password_new !== this.repeat_password_new) {
        this.$swal({
          position: 'center',
          icon: 'error',
          title: 'Las contraseñas no coinciden',
          showConfirmButton: false,
          timer: 2000
        })
        return
      }
      this.saving = true
      try {
        const response = await axios.post('general/b2c/reset/' + this.id, {
          password: this.password_actual,
          password_nueva: this.password_new
        })
        if (response.status === 200) {
          this.password_actual = ''
          this.password_new = ''
          this.repeat_password_new = ''
          this.$swal({
            position: 'center',
            icon: 'success',
            title: 'Contraseña actualizado correctamente',
            showConfirmButton: false,
            timer: 2000
          })
        }
      } catch (error) {
        this.$swal({
          position: 'center',
          icon: 'error',
          title: 'La contraseña actual es incorrecta',
          showConfirmButton: false,
          timer: 2000
        })
      } finally {
        this.saving = false
      }
    },
    async updateCompany() {
      this.saving = true
      try {
        const formData = new FormData()
        formData.append('file', this.file)
        formData.append('company_name', this.company_name)
        formData.append('company_ruc', this.company_ruc)
        formData.append('company_rec_type_id', this.company_rec_type_id)
        formData.append('company_bus_group_id', this.company_bus_group_id)
        formData.append('company_cus_type_id', this.company_cus_type_id)
        formData.append('company_bus_type_id', this.company_bus_type_id)
        formData.append('company_gat_connection_id', this.company_gat_connection_id)
        formData.append('company_contact_name', this.company_contact_name)
        formData.append('company_contact_lastname', this.company_contact_lastname)
        formData.append('company_contact_email', this.company_contact_email)
        formData.append('company_contact_cellphone', this.company_contact_cellphone)
        const response = await axios.post('general/company/update/' + this.id_company, formData)
        if (response.status === 200) {
          localStorage.setItem('company_name', this.company_name)
          this.$swal({
            position: 'center',
            icon: 'success',
            title: 'Empresa actualizado correctamente',
            showConfirmButton: false,
            timer: 2000
          })
        }
      } catch (e) {
        this.$swal({
          position: 'center',
          icon: 'error',
          title: 'Completar los datos correctamente',
          showConfirmButton: false,
          timer: 2000
        })
      } finally {
        this.saving = false
      }
    },
    async updateEmpresa() {
      this.saving = true
      try {
        const formData = new FormData()
        formData.append('valor', this.cellphone_empresa)
        const respuesta = await axios.post('general/elements/empresa/', formData)
        if (respuesta.status === 200) {
          localStorage.setItem('cellphone', this.cellphone_empresa)
          this.$swal({
            position: 'center',
            icon: 'success',
            title: 'Editado correctamente',
            showConfirmButton: false,
            timer: 2000
          })
        }
      } catch (error) {
        this.$swal({
          position: 'center',
          icon: 'error',
          title: 'Completar los datos correctamente',
          showConfirmButton: false,
          timer: 2000
        })
      } finally {
        this.saving = false
      }
    },
    async gateway_add() {
      if (!this.add_gateway) {
        this.$swal({
          position: 'center',
          icon: 'error',
          title: 'Completar los datos correctamente',
          showConfirmButton: false,
          timer: 2000
        })
        return
      }
      try {
        const response = await axios.post('general/company/addGateway/', { name: this.add_gateway })
        if (response.status === 200) {
          this.add_gateway = ''
          this.getSelects()
          this.$swal({
            position: 'center',
            icon: 'success',
            title: 'Se añadio Correctamente',
            showConfirmButton: false,
            timer: 2000
          })
        }
      } catch (error) {
        this.$swal({
          position: 'center',
          icon: 'error',
          title: 'Completar los datos correctamente',
          showConfirmButton: false,
          timer: 2000
        })
      }
    },
    deleteGateway(id) {
      this.$swal({
        title: '¿Estas seguro de eliminar la pasarela de pago?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (!result.isConfirmed) return
        axios.delete('general/company/deleteGateway/' + id)
          .then((res) => {
            if (res.status === 200) {
              this.getSelects()
              this.$swal({
                position: 'center',
                icon: 'success',
                title: 'Se elimino correctamente',
                showConfirmButton: false,
                timer: 2000
              })
            }
          })
          .catch(() => {
            this.$swal({
              position: 'center',
              icon: 'error',
              title: 'Pasarela en uso, no es posible eliminar',
              showConfirmButton: false,
              timer: 2000
            })
          })
      })
    },
    async loadNubefact() {
      if (!this.id_company) {
        this.$swal({ icon: 'warning', title: 'No hay empresa seleccionada en la sesión.' })
        return
      }
      this.nubefactLoading = true
      try {
        const res = await axios.get('general/company/' + this.id_company + '/nubefact')
        const data = (res.data && res.data.data) || {}
        this.nubefact.enabled = !!data.enabled
        this.nubefact.url = this.cleanUrl(data.url)
        this.nubefact.token = ''
        this.nubefact.serie_factura = data.serie_factura || 'FFF1'
        this.nubefact.serie_boleta = data.serie_boleta || 'BBB1'
        this.nubefact.igv = data.igv != null ? Number(data.igv) : 18
        this.nubefactMeta.has_token = !!data.has_token
        this.nubefactMeta.token_masked = data.token_masked || ''
        this.nubefactMeta.source = data.source || ''
        this.nubefactMeta.configured = !!data.configured
        this.nubefactLoaded = true
      } catch (e) {
        const msg = (e.response && e.response.data && e.response.data.message) || 'No se pudo cargar la configuración.'
        this.$swal({ icon: 'error', title: msg })
      } finally {
        this.nubefactLoading = false
      }
    },
    async saveNubefact() {
      if (!this.id_company) return
      this.nubefact.url = this.cleanUrl(this.nubefact.url)
      if (this.nubefact.enabled && !this.nubefact.url) {
        this.$swal({ icon: 'warning', title: 'La URL de Nubefact es obligatoria si activas la facturación.' })
        return
      }
      if (this.nubefact.enabled && !this.nubefact.token && !this.nubefactMeta.has_token) {
        this.$swal({ icon: 'warning', title: 'Debes indicar el token de Nubefact.' })
        return
      }
      this.saving = true
      try {
        const payload = {
          enabled: !!this.nubefact.enabled,
          url: this.nubefact.url,
          serie_factura: (this.nubefact.serie_factura || '').toUpperCase(),
          serie_boleta: (this.nubefact.serie_boleta || '').toUpperCase(),
          igv: this.nubefact.igv
        }
        if (this.nubefact.token && this.nubefact.token.trim() !== '') {
          payload.token = this.nubefact.token.trim()
        }
        const res = await axios.put('general/company/' + this.id_company + '/nubefact', payload)
        const data = (res.data && res.data.data) || {}
        this.nubefact.token = ''
        this.nubefactMeta.has_token = !!data.has_token
        this.nubefactMeta.token_masked = data.token_masked || ''
        this.nubefactMeta.source = data.source || 'company'
        this.nubefactMeta.configured = !!data.configured
        this.nubefact.enabled = !!data.enabled
        this.nubefact.url = this.cleanUrl(data.url || this.nubefact.url)
        this.nubefact.serie_factura = data.serie_factura || this.nubefact.serie_factura
        this.nubefact.serie_boleta = data.serie_boleta || this.nubefact.serie_boleta
        this.nubefact.igv = data.igv != null ? Number(data.igv) : this.nubefact.igv
        this.$swal({
          icon: 'success',
          title: (res.data && res.data.message) || 'Configuración guardada.',
          timer: 1800,
          showConfirmButton: false
        })
      } catch (e) {
        const msg = (e.response && e.response.data && e.response.data.message) || 'No se pudo guardar.'
        this.$swal({ icon: 'error', title: msg })
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.section-title {
  margin: 22px 0 12px;
  font-size: 15px;
  font-weight: 600;
  color: #ff3128;
}
.logo-row {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
  margin-bottom: 8px;
}
.logo-preview {
  width: 160px;
  height: 160px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #ececec;
  background: #fafafa;
  display: flex;
  align-items: center;
  justify-content: center;
}
.logo-preview img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.logo-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.add-row {
  display: flex;
  gap: 8px;
}
.add-row input {
  flex: 1;
}
.add-row .btn {
  min-width: 48px;
}
.simple-table {
  width: 100%;
  margin-top: 16px;
  border-collapse: collapse;
}
.simple-table th,
.simple-table td {
  text-align: left;
  padding: 10px 12px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
}
.simple-table th {
  color: #888;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
}
.simple-table .btn {
  min-width: auto;
  padding: 8px 12px;
}
</style>
